<template>
    <v-card>
        <v-card-title>
            <h1>{{ title }} {{ userName ? 'for' : '' }} {{ userName }}</h1>
            <v-spacer></v-spacer>
            <v-select label="Filter by Status" v-model="status" :items="['All', 'Draft', 'Submitted', 'Order Pending', 'Order Placed', 'Expired']" hide-details></v-select>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details clearable></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :pagination.sync="pagination" :total-items="pagination.totalItems" hide-actions>
            <v-progress-linear v-if="loading" slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td v-for="h in headers" :class="{'hide-column' : h.class == 'hide-column', 'capitalize' : true, 'text-xs-center' : h.align == 'center', 'text-xs-left' : h.align == 'left', 'text-xs-right' : h.align == 'right'}">
                    <span v-if="h.href" style="white-space:nowrap;">
                        <v-btn :href="getLink(props.item, h)">{{ h.text }}</v-btn>
                        <v-tooltip top v-if="(props.item.status != 'expired')&& !$vuetify.breakpoint.xsOnly">
                            <span>Duplicate</span>
                            <v-btn slot="activator" :disabled="disableDupe" icon @click.stop="confirmLoadPage(getLink(props.item, h) + '/copy', 'Copy Quote?', 'This will create an exact duplicate of the quote.')">
                                <v-icon small>fas fa-copy</v-icon>
                            </v-btn>
                        </v-tooltip>
                        <v-tooltip top v-if="false && !$vuetify.breakpoint.xsOnly">
                            <span>Re-Quote</span>
                            <v-btn slot="activator" icon :href="getLink(props.item, h) + '/requote'">
                                <v-icon small>fas fa-sync-alt</v-icon>
                            </v-btn>
                        </v-tooltip>
                    </span>
                    <span v-else-if="h.value == 'created_at'">
                        {{ formatDate(findCelData(props.item, h.value)) }}
                    </span>
                    <span v-else-if="h.value == 'status'">
                        {{ props.item.status.replace('_', ' ') }}
                    </span>
                    <span v-else-if="h.value == 'name'">
                        {{ findCelData(props.item, h.value) }}<v-icon small>{{ getAdminIcon(props.item.role_id) }}</v-icon>
                    </span>
                    <span v-else>
                        {{ findCelData(props.item, h.value) }}
                    </span>
                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="pages > 1">
            <v-pagination :total-visible="10" v-model="current_page" :length="pages"></v-pagination>
        </div>
        <v-dialog v-model="dialog_display" width="300">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{ dialog_title }}
                </v-card-title>
                <v-card-text v-if="!dialog_loading">
                    {{ dialog_description }}
                </v-card-text>
                <v-card-text v-else>
                    <div class="text-xs-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="dialog_loading" flat @click="dialog_loading = true; loadPage(dialog_destination_url, dialog_title, 'confirmation_dialog'); disableDupe = true;">Yes</v-btn>
                    <v-btn color="primary" flat @click="dialog_display = false; dialog_loading = false; disableDupe = false;">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
const request = require('superagent');
const debounce = require('debounce');
import DataGrid from './DataGrid.vue';

export default {
    extends: DataGrid,
    props: ['userId', 'userName'],
    data: function() {
        return {
            status: 'All',
            pagination: { sortBy: 'created_at', descending: true },
            dialog_display: false,
            dialog_destination_url: null,
            dialog_title: null,
            dialog_description: null,
            dialog_loading: false,
            disableDupe: false
        }
    },
    mounted() {

    },
    computed: {

    },
    methods: {
        getData: function() {
            this.loading = true;
            const { sortBy, descending, page, rowsPerPage } = this.pagination;
            var _status = this.status != 'All' ? this.status.toLowerCase().replace(' ', '_') : null;
            return request
                .get(this.url)
                .query({ status: _status, page: this.current_page, sort: (descending ? 'desc' : 'asc'), sortBy: sortBy, search: this.search, user_id: this.userId });
        },
        loadPage: function(url, action, label) {
            if (typeof action != 'undefined') {
                this.ga(action, label, function() {
                    document.location = url;
                });
            } else {
                document.location = url;
            }
        },
        confirmLoadPage: function(url, title, copy) {
            this.dialog_destination_url = url;
            this.dialog_title = title;
            this.dialog_description = copy;
            this.dialog_display = true;
            this.disableDupe = true;
        },
        ga: function(action, label, callback) {
            if (typeof callback != 'function') {
                callback = function() {};
            }
            if (typeof gtag != 'undefined') {
                window.dataLayer.push({
                    event: 'ga_event',
                    event_category: 'tutco-portal',
                    event_label: label,
                    event_action: action,
                    eventCallback: callback
                });

            } else {
                callback();
            }
        },
    },
    watch: {
        'status': function() {
            var g = this;
            this.loading = true;
            this.getData().end((err, res) => {
                g.data = res.body.data;
                g.pagination.page = 1;
                g.pagination.totalItems = res.body.total;
                g.pagination.rowsPerPage = res.body.per_page;
                g.loading = false;
            });
        }
    }
}

</script>
